import { getStateStore } from '../../stores';

const state = getStateStore('ipc');

export const initializeHostGamepadEvents = () => {
  state.hostGamepadState.addListener((hostGamepadState) => {
    const ids = hostGamepadState.gamepads.filter((gamepad) => gamepad.isPhysical).map((gamepad) => gamepad.gamepadId);
    const gamepadState = state.gamepadState.currentState;
    gamepadState.playerMappings.host = { gamepadIndexes: ids };
    state.gamepadState.updateState({ ...gamepadState });
  });
};
